import React, { Component } from "react";
import { Collapse, Checkbox, Slider, Select } from "antd";

const { Panel } = Collapse;
const CheckboxGroup = Checkbox.Group;
const importanceOptions = ["Top", "High", "Mid", "Low", "Unknown"];
const qualityOptions = [
  "FA",
  "GA",
  "A",
  "B",
  "C",
  "Start",
  "Stub",
  "FL",
  "List",
  "Unassessed",
];

export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedImportance: importanceOptions,
      checkedQuality: qualityOptions,
      indeterminate: true,
    };
  }

  onChangeImportance = (checkedImportance) => {
    this.setState({
      checkedImportance,
      indeterminate:
        !!checkedImportance.length &&
        checkedImportance.length < importanceOptions.length,
      checkAll: checkedImportance.length === importanceOptions.length,
    });
    this.props.changeIncludedImportances(checkedImportance);
  };

  onChangeQuality = (checkedQuality) => {
    this.setState({
      checkedQuality,
      indeterminate:
        !!checkedQuality.length &&
        checkedQuality.length < qualityOptions.length,
      checkAll: checkedQuality.length === qualityOptions.length,
    });
    this.props.changeIncludedQualities(checkedQuality);
  };

  onChangeImagesRange = (value) => {
    this.props.changeImagesRange(value);
  };

  onChangeCategories = (value) => {
    this.props.changeCategories(value);
  };

  render() {
    return (
      <div id="filters" className="pane">
        <Collapse ghost={true} defaultActiveKey={["0", "1", "2", "3"]}>
          <Panel header="Quality">
            <CheckboxGroup
              options={qualityOptions}
              value={this.state.checkedQuality}
              onChange={this.onChangeQuality}
            />
          </Panel>
          <Panel header="Importance">
            <CheckboxGroup
              options={importanceOptions}
              value={this.state.checkedImportance}
              onChange={this.onChangeImportance}
            />
          </Panel>
          <Panel header="Number of images">
            <Slider
              range={{ draggableTrack: true }}
              defaultValue={[0, this.props.maxNumberOfImages]}
              max={this.props.maxNumberOfImages}
              onChange={this.onChangeImagesRange}
            />
          </Panel>
          <Panel header="Categories">
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="All categories"
              options={this.props.allCategories}
              onChange={this.onChangeCategories}
            />
          </Panel>
        </Collapse>
      </div>
    );
  }
}
